export default __webpack_public_path__ + "static/media/chanon.2098c248.png";